// ═══════════════════════════════════════════════════════════════════════════════
// Lock document scroll while main app uses inner scroll (PWA / standalone only)
// ═══════════════════════════════════════════════════════════════════════════════

import { useEffect } from 'react';

export const MAIN_APP_DOCUMENT_LOCK_CLASS = 'fdh-main-app-shell';

export const useMainAppDocumentLock = (enabled: boolean): void => {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    document.documentElement.classList.add(MAIN_APP_DOCUMENT_LOCK_CLASS);
    return () => {
      document.documentElement.classList.remove(MAIN_APP_DOCUMENT_LOCK_CLASS);
    };
  }, [enabled]);
};
